import React from 'react'
import { withRouter } from 'react-router-dom'
import { Paper } from '@material-ui/core'
import Summary from './Summary'
import Table from './Table/Table'
import Headline from './Headline'
import PolicyEditor from './PolicyEditor'

function Content({ isEditorActive, editorSwitcher, history, location }) {
  return (
    <div className="ma-content">
      <Paper className="ma-paper">
        <Headline switcher={editorSwitcher} />
        {isEditorActive ? (
          <PolicyEditor isStateCriteria />
        ) : (
          <>
            <Summary />
            <Table
              isStateCriteria
              alwaysShowTableHead
              history={history}
              location={location}
            />
          </>
        )}
      </Paper>
    </div>
  )
}

export default withRouter(Content)
